'use client'

import { useRef } from "react"

type FiltersToggleButtonProps = {
    filtersSidebarId?: string,
    contentId?: string
}

export default function FiltersToggleButton({
    filtersSidebarId = "resultats-filtres",
    contentId = "resultats-contenu"
}: FiltersToggleButtonProps) {

    const ref = useRef<HTMLButtonElement>(null)

    return (
        <>
            <button ref={ref} className="button masquer justify-content-start bg-primary text-white absolute" onClick={() => {
                if (document.getElementById(filtersSidebarId).classList.contains("w-0")) {
                    document.getElementById(filtersSidebarId).classList.remove("w-0")
                    document.getElementById(contentId).classList.add("col-xl-9", "col-lg-8")
                    document.getElementById(contentId).classList.remove("col-xl-12")
                    Array.from(document.getElementById(filtersSidebarId).children).forEach(function (i) { i.classList.remove("d-none") })
                    ref.current.querySelectorAll('i')[1].classList.remove('fi-rr-eye')
                    ref.current.querySelectorAll('i')[1].classList.add('fi-rr-eye-crossed')
                    ref.current.querySelectorAll('span')[0].textContent = 'Masquer les filtres'
                    Array.from(document.getElementById(contentId).querySelectorAll('.resultats .row > div')).forEach(function (i) { i.classList.add("col-xl-4") })
                    Array.from(document.getElementById(contentId).querySelectorAll('.resultats .row > div')).forEach(function (i) { i.classList.remove("col-xl-3", "col-lg-4") })
                }
                else {
                    document.getElementById(filtersSidebarId).classList.add("w-0")
                    document.getElementById(contentId).classList.remove("col-xl-9", "col-lg-8")
                    document.getElementById(contentId).classList.add("col-xl-12")
                    Array.from(document.getElementById(filtersSidebarId).children).forEach(function (i) { i.classList.add("d-none") })
                    ref.current.querySelectorAll('i')[1].classList.remove('fi-rr-eye-crossed')
                    ref.current.querySelectorAll('i')[1].classList.add('fi-rr-eye')
                    ref.current.querySelectorAll('span')[0].textContent = 'Afficher les filtres'
                    Array.from(document.getElementById(contentId).querySelectorAll('.resultats .row > div')).forEach(function (i) { i.classList.remove("col-xl-4") })
                    Array.from(document.getElementById(contentId).querySelectorAll('.resultats .row > div')).forEach(function (i) { i.classList.add("col-xl-3", "col-lg-4") })
                }

            }}>
                {/*<span className="pill rounded-full bg-terracotta mr-10">
                    2
                </span>*/}
                <i className="fi fi-rr-settings-sliders mr-20" />
                <i className="fi fi-rr-eye-crossed" />
                <span>Masquer les filtres</span>
            </button>
        </>
    )
}